export default {
  searchText: '',
  selectedYear: 0
}
